import React, { useEffect, useState, useRef } from 'react';
import './MobilePage.less';
import {
  Form,
  Button,
  Input,
  Table,
  Select,
  message,
  Tabs,
  ConfigProvider,
  Modal,
  DatePicker,
} from 'antd';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { getTableScroll } from '../../utils/getHeight';
import { useAppConfig } from '@state';
import { utils } from '@ohif/core';
import oneWeekDay from '../../utils/getOneWeekDay.js';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import { useNavigate, useLocation } from 'react-router-dom';

dayjs.locale('zh-cn');
const { apiService } = utils;
const { TabPane } = Tabs;

const MobilePage = ({
  studies,
  studiesTotal,
  tableLoading,
  onValuesChange,
  // filterValues,
  filtersMeta,
  handleTabChange,
  normalizeDataIndex,
  getDay,
  isEmpty,
}: withAppTypes) => {
  const tableRef = useRef();
  const eleRef = useRef();
  const myform = useRef();
  const [scrollY, setScrollY] = useState<any>();
  const [selectRow, setSelectRow] = useState<any>();
  const [selectPdfRowID, setSelectPdfRowID] = useState<any>();
  const [modalities, setModalities] = useState<string>('');
  const [allModalities, setAllModalities] = useState([]);
  //临床诊断
  const [clinicalDiagnosis, setClinicalDiagnosis] = useState('');
  //检查所见
  const [checkLook, setCheckLook] = useState('');
  //诊断结果
  const [diagnosticResults, setDiagnosticResults] = useState('');
  //病史信息
  const [patient_history, setPatient_history] = useState('');
  const [messageApi, contextHolder] = message.useMessage();
  const [href, setHref] = useState<string>('');
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [appConfig] = useAppConfig();
  const [newFilterValues, setNewFilterValues] = useState({});
  const [sortName, setSortDataName] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [dept, setDept] = useState([]);
  const [person, setPerson] = useState([]);
  const [currentState, setCurrentState] = useState('');
  const [hideQuery, setHideQuery] = useState(false);
  const [rowData, setRowData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const lastTouchTime = useRef(0);
  const touchTimeout = useRef(null);
  const sessionQueryFilterValues = sessionStorage.getItem('filterValues')
    ? JSON.parse(sessionStorage.getItem('filterValues'))
    : {};
  const [filterValues, _setFilterValues] = useState({
    currentPage: '1',
    pageSize: 10,
    no_type: 'patient_id',
    sort: 'r.register_time desc',
    register_time_begin: oneWeekDay,
    register_time_end: dayjs().format('YYYY-MM-DD'),
    ...sessionQueryFilterValues,
  });
  const [newStudies, setStudies] = useState([]);
  const [newStudiesTotal, setStudiesTotal] = useState(0);
  const [newTableLoading, setTableLoading] = useState(false);

  const columns = [
    {
      title: '',
      dataIndex: 'index',
      key: 'index',
      width: 40,
      sortOrder: null,
    },
    {
      title: 'register_key',
      dataIndex: 'register_key',
      hidden: true,
    },
    {
      title: 'studyinstanceuid',
      dataIndex: 'studyinstanceuid',
      hidden: true,
    },
    {
      title: '状态',
      dataIndex: 'state',
      key: 'state',
      width: 120,
      ellipsis: true,
      render: (value, record, index) => {
        if (value === '0') {
          return <span>待检查</span>;
        } else if (value === '1') {
          return <span style={{ color: 'orange' }}>待诊断</span>;
        } else if (value === '2') {
          return <span style={{ color: '#07c160' }}>已诊断</span>;
        } else if (value === '3' || value === '4' || value === '5') {
          return <span style={{ color: '#999999' }}>已审核</span>;
        }
      },
    },
    {
      title: '患者姓名',
      dataIndex: 'chinese_name',
      key: 'chinese_name',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: false,
      sortOrder: sortName === 'p.chinese_name' ? sortDirection + 'end' : null,
      width: 180,
      ellipsis: true,
    },
    {
      title: '性别',
      dataIndex: 'sex',
      key: 'sex',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: false,
      sortOrder: sortName === 'p.sex' ? sortDirection + 'end' : null,
      width: 70,
      ellipsis: true,
    },
    {
      title: '年龄',
      dataIndex: 'age',
      key: 'age',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.age' ? sortDirection + 'end' : null,
      width: 70,
      ellipsis: true,
    },
    {
      title: '检查类型',
      dataIndex: 'modality_code',
      key: 'modality_code',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.modality_code' ? sortDirection + 'end' : null,
      width: 100,
      ellipsis: true,
    },
    {
      title: '登记时间',
      dataIndex: 'register_time',
      key: 'register_time',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.register_time' ? sortDirection + 'end' : null,
      width: 220,
      ellipsis: true,
    },
    {
      title: 'ID号',
      dataIndex: 'patient_id',
      key: 'patient_id',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'p.patient_id' ? sortDirection + 'end' : null,
      width: 130,
      ellipsis: true,
    },
    {
      title: '住院号',
      dataIndex: 'in_no',
      key: 'in_no',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.in_no' ? sortDirection + 'end' : null,
      ellipsis: true,
    },
    {
      title: '门诊号',
      dataIndex: 'out_no',
      key: 'out_no',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.out_no' ? sortDirection + 'end' : null,
      ellipsis: true,
    },
    {
      title: '检查号',
      dataIndex: 'study_id',
      key: 'study_id',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.study_id' ? sortDirection + 'end' : null,
      width: 150,
      ellipsis: true,
    },
    {
      title: '检查部位',
      dataIndex: 'bodypart_name',
      key: 'bodypart_name',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.bodypart_name' ? sortDirection + 'end' : null,
      width: 150,
      ellipsis: true,
    },
    {
      title: '送检部门',
      dataIndex: 'register_dept',
      key: 'register_dept',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.register_dept' ? sortDirection + 'end' : null,
      width: 120,
      ellipsis: true,
    },
    {
      title: '送检人员',
      dataIndex: 'register_man',
      key: 'register_man',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      sortOrder: sortName === 'r.register_man' ? sortDirection + 'end' : null,
      width: 120,
      ellipsis: true,
    },
    {
      title: '图像数',
      dataIndex: 'image_num',
      key: 'image_num',
      width: 100,
      ellipsis: true,
      sortOrder: null,
    },
  ];

  useEffect(() => {
    document.documentElement.style.setProperty('--scroll-y', `${scrollY}px`);
  }, [scrollY]);

  useEffect(() => {
    setStudies(studies);
    setStudiesTotal(studiesTotal);
    setTableLoading(tableLoading);
  }, [studies, studiesTotal, tableLoading]);

  const handleResize = () => {
    setTimeout(() => {
      if (tableRef.current) {
        const parentHeight = tableRef.current.offsetHeight; // 直接使用 table-wrap 的高度
        console.log('parentHeight:', parentHeight);
        const scrollHeight = Math.round(parentHeight - 100);
        setScrollY(scrollHeight);
        document.documentElement.style.setProperty('--scroll-y', `${scrollHeight}px`);
      } else {
        console.log('tableRef.current 不存在');
      }
    }, 100);
  };

  useEffect(() => {
    const flag = localStorage.getItem('page');
    if (flag === 'start') {
      setHideQuery(false);
    } else {
      setHideQuery(true);
    }

    setHref(window.location.origin);

    //同时请求检查类型的接口获取检查类型
    apiService({
      uri: '/api/reglist/getModality',
      method: 'GET',
      type: null,
    })
      .then(res => {
        if (res?.Data) {
          const data = res.Data;
          const normalizedData = normalizeDataIndex(data, true);
          const arr = [];
          normalizedData.map(item => {
            if (!arr.includes(item.modality_code)) {
              arr.push(item.modality_code);
            }
          });
          const newArr = [];
          arr.map(item => {
            newArr.push({ label: item, value: item });
          });
          setAllModalities(newArr);
        }
      })
      .catch(res => {
        console.log('请求检查类型报错', res);
      });

    //请求接口获取检查科室
    apiService({
      uri: '/api/reglist/getRegisterDept',
      method: 'POST',
      type: null,
    })
      .then(res => {
        if (res?.Data) {
          const data = res.Data;
          const normalizedData = normalizeDataIndex(data, true);
          const arr = [];
          normalizedData.map(item => {
            arr.push({
              label: item.registerdept_name,
              value: item.registerdept_name,
            });
          });

          setDept(arr);
        }
      })
      .catch(res => {
        console.log('请求送检部门报错', res);
      });

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  const handleChangeDept = value => {
    myform.current?.setFieldsValue({ register_man: undefined });
    setPerson([]);
    const formData = new FormData();
    formData.append('dept_name', value);
    //请求接口获取检查科室
    apiService({
      uri: '/api/reglist/getRegisterMan',
      method: 'POST',
      data: formData,
    })
      .then(res => {
        if (res?.Data) {
          const data = res.Data;
          const normalizedData = normalizeDataIndex(data, true);
          const arr = [];
          normalizedData.map(item => {
            arr.push({
              label: item.registerman_name,
              value: item.registerman_name,
            });
          });
          setPerson(arr);
        }
      })
      .catch(res => {
        console.log('请求送检人员报错', res);
      });
  };

  useEffect(() => {
    if (filterValues) {
      const obj = { ...filterValues };
      Object.keys(filterValues).forEach(key => {
        if (key === 'register_time_begin') {
          obj[key] = filterValues.register_time_begin
            ? dayjs(filterValues.register_time_begin)
            : '';
        }
        if (key === 'register_time_end') {
          obj[key] = filterValues.register_time_end ? dayjs(filterValues.register_time_end) : '';
        }
      });

      setNewFilterValues(obj);

      form.setFieldsValue({
        chinese_name: obj.chinese_name,
        register_time_begin: obj.register_time_begin,
        register_time_end: obj.register_time_end,
        patient_id: obj.no_type === 'patient_id' && obj.no_value,
        in_no: obj.no_type === 'in_no' && obj.no_value,
        out_no: obj.no_type === 'out_no' && obj.no_value,
        study_id: obj.no_type === 'study_id' && obj.no_value,
        no_type: obj.no_type,
        no_value: obj.no_value,
        check_view2: obj.check_view2,
        diagnosis_result2: obj.diagnosis_result2,
        modality_code: obj.modality_code,
        register_dept: obj.register_dept,
        register_man: obj.register_man,
      });

      setSortDataName(obj.sort?.split(' ')[0]);
      setSortDirection(obj.sort?.split(' ')[1]);
    }
  }, [filterValues]);

  // const dataSource = studies;
  const rowClassName = (record, index) => {
    if (record.index === selectRow) {
      return 'selected-style';
    } else {
      return index % 2 === 0 ? 'even-row' : 'odd-row';
    }
  };

  const getData = (params?) => {
    _setFilterValues({
      ...params,
      register_time_end: params.originRegisterTimeEnd
        ? dayjs(params.originRegisterTimeEnd).format('YYYY-MM-DD')
        : params.register_time_end,
    });

    const newParams = { ...params };
    if (params.no_type && !params.no_value) {
      delete newParams.no_type;
      delete newParams.no_value;
    }

    sessionStorage.setItem(
      'filterValues',
      JSON.stringify({
        ...newParams,
        register_time_end: params.originRegisterTimeEnd
          ? dayjs(params.originRegisterTimeEnd).format('YYYY-MM-DD')
          : params.register_time_end,
      })
    );

    const formData = new FormData();
    if (params) {
      for (const i in params) {
        if (i !== 'originRegisterTimeEnd' && i !== 'no_type' && i !== 'no_value') {
          formData.append(i, params[i]);
        }
      }
    }

    setTableLoading(true);

    apiService({
      uri: '/api/reglist/stream-page',
      method: 'POST',
      data: formData,
      type: null,
    })
      .then(res => {
        if (res?.Data) {
          setTableLoading(false);
          let data = res.Data;
          if (data.length === 0) {
            messageApi.warning('当前查询条件未查询到数据！');
            return;
          } else {
            handleResize();
            if (eleRef.current) {
              eleRef.current.scrollIntoView({ behavior: 'smooth' });
            }

            setHideQuery(true);
          }
          data = data.map((item, index) => {
            item.index = (params.currentPage - 1) * params.pageSize + index + 1;
            return item;
          });
          const total = Number(res.totalCount);
          const normalizedData = normalizeDataIndex(data, true);
          setStudies(normalizedData);
          setStudiesTotal(total);
        }
      })
      .catch(res => {
        setTableLoading(false);
        console.log('请求检查列表报错', res);
      });
  };

  const getSecondDay = date => {
    const secondDay = new Date(date);
    secondDay.setDate(secondDay.getDate() + 1);
    return dayjs(secondDay).format('YYYY-MM-DD') + ' 00:00:00';
  };

  const onFinish = (values: any) => {
    if (values.no_value && !values.no_type) {
      message.warning('请先选择编号类型！');
      return false;
    }
    interface ob {
      [key: string]: string | number | boolean;
    }
    const newValues: ob = { ...values };

    //如果没有选择编号，把编号的值都清空
    if (values.no_type) {
      newValues[values.no_type] = values.no_value;
    }
    if (!values.no_type) {
      newValues.patient_id = '';
      newValues.in_no = '';
      newValues.out_no = '';
      newValues.study_id = '';
    }

    //如果选择了编号，则除了该编号对应的值其他值都清空
    const typeArr = ['patient_id', 'in_no', 'out_no', 'study_id'];
    const newArr = typeArr.filter(item => item !== values.no_type);
    newArr.map((item, index) => {
      newValues[item] = '';
    });

    const register_time_begin = values.register_time_begin
      ? values.register_time_begin.format('YYYY-MM-DD') + ' 00:00:00'
      : null;
    const register_time_end = values.register_time_end
      ? values.register_time_end.format('YYYY-MM-DD') + ' 00:00:00'
      : null;
    console.log('register_time_end==== ', register_time_end);
    newValues.register_time_begin = register_time_begin;
    newValues.register_time_end = register_time_end;

    const newData = { ...filterValues, ...newValues };
    Object.keys(newData).forEach(key => {
      if (!newData[key] || newData[key] === '' || newData[key].length === 0) {
        delete newData[key];
      }

      if (key === 'register_time_end' && newData.register_time_end) {
        newData.originRegisterTimeEnd = newData.register_time_end;
        newData.register_time_end = getSecondDay(newData.register_time_end);
      }

      if (key === 'register_time_begin' && newData.register_time_begin) {
        newData.register_time_begin =
          dayjs(newData.register_time_begin).format('YYYY-MM-DD') + ' 00:00:00';
      }
    });
    getData(newData);
  };

  const handleChangeTable = (pagination, filters, sorter) => {
    let sort = '';
    if (sorter.columnKey) {
      if (
        sorter.columnKey === 'patient_id' ||
        sorter.columnKey === 'chinese_name' ||
        sorter.columnKey === 'sex'
      ) {
        const order =
          sorter.order === 'ascend' ? 'asc' : sorter.order === 'descend' ? 'desc' : sorter.order;
        if (sortDirection && sortName.indexOf(sorter.columnKey) == -1) {
          sort = 'p.' + sorter.columnKey + ' ' + 'asc';
        } else {
          sort = 'p.' + sorter.columnKey + ' ' + (order || 'desc');
        }
      } else {
        const order =
          sorter.order === 'ascend' ? 'asc' : sorter.order === 'descend' ? 'desc' : sorter.order;
        if (sortDirection && sortName.indexOf(sorter.columnKey) == -1) {
          sort = 'r.' + sorter.columnKey + ' ' + 'asc';
        } else {
          sort = 'r.' + sorter.columnKey + ' ' + (order || 'desc');
        }
      }
    }

    getData({
      ...filterValues,
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
      sort: sort,
      originRegisterTimeEnd: null,
    });
  };

  const getStudyInstanceUid = register_key => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('register_key', register_key);
      // 请求接口获取检查科室
      apiService({
        uri: '/api/reglist/getSuid',
        method: 'POST',
        data: formData,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log('请求报错', err);
          reject(err);
        });
    });
  };

  //点击“影像”按钮
  const handleViewer = async flag => {
    const selectViewerRowID = await getStudyInstanceUid(selectPdfRowID);
    if (!selectViewerRowID) {
      messageApi.warning('请先选中病人记录!');
      return false;
    }
    const currentSearchParams = new URLSearchParams();
    currentSearchParams.set('p_studyInstanceUid', selectViewerRowID);
    const queryString = currentSearchParams.toString();
    if (flag === 'image') {
      navigate(
        `/reportdetail${queryString ? `?${queryString}&from=mobilepage&flag=viewer` : 'from=mobilepage&flag=viewer'}`,
        {
          state: {
            rowData: rowData,
          },
        }
      );
    } else if (flag === 'pdf') {
      navigate(
        `/reportdetail${queryString ? `?${queryString}&from=mobilepage&flag=pdf` : 'from=mobilepage&flag=pdf'}`,
        {
          state: {
            rowData: rowData,
          },
        }
      );
    }
  };

  //清空搜索条件
  const handleReset = () => {
    const resetValues = {
      register_time_begin: dayjs(oneWeekDay),
      register_time_end: dayjs(),
      chinese_name: '',
      patient_id: '',
      in_no: '',
      out_no: '',
      study_id: '',
      no_value: '',
      no_type: 'patient_id',
      check_view2: '',
      diagnosis_result2: '',
      modality_code: [],
      register_dept: '',
      register_man: '',
    };

    // 更新表单值
    form.setFieldsValue(resetValues);

    // 同步更新 newFilterValues
    setNewFilterValues(resetValues);

    // 调用 getData 重置数据
    getData({
      ...filterValues,
      ...resetValues,
      register_time_begin: resetValues.register_time_begin.format('YYYY-MM-DD') + ' 00:00:00',
      register_time_end: resetValues.register_time_end.format('YYYY-MM-DD') + ' 00:00:00',
      currentPage: 1,
      sort: 'r.register_time desc',
    });
  };

  const handleHidden = () => {
    setHideQuery(!hideQuery);
  };

  //切换各种号
  const handleChangeType = value => {
    myform.current?.setFieldsValue({ no_value: '' });
  };

  const items = [
    {
      key: '1',
      label: '报告信息',
      children: (
        <div className="report_message">
          {selectRow && (
            <>
              <div>
                <h3>病史信息</h3>
                <p>{patient_history}</p>
              </div>
              <div>
                <h3>临床诊断</h3>
                <p>{clinicalDiagnosis}</p>
              </div>
              {Number(currentState) >= 3 && (
                <>
                  <div>
                    <h3>检查所见</h3>
                    <p>{checkLook}</p>
                  </div>
                  <div>
                    <h3>诊断结果</h3>
                    <p>{diagnosticResults}</p>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      ),
    },
  ];

  const handleTouchStart = record => event => {
    const currentTime = new Date().getTime();
    const timeDiff = currentTime - lastTouchTime.current;

    // 双击时间窗口（300ms 内）
    if (timeDiff < 300 && timeDiff > 0) {
      if (touchTimeout.current) {
        clearTimeout(touchTimeout.current);
      }
      handleDoubleTap(record); // 执行双击逻辑
    } else {
      // 单次点击，延迟执行以等待可能的第二次点击
      touchTimeout.current = setTimeout(() => {
        setSelectRow(record.index);
        setSelectPdfRowID(record.register_key);
        setModalities(record.modalities);
        setClinicalDiagnosis(record.clinical_diagnosis);
        setCheckLook(record.check_view2);
        setDiagnosticResults(record.diagnosis_result2);
        setPatient_history(record.patient_history);
        setCurrentState(record.state);
        setRowData(record);
      }, 300);
    }

    lastTouchTime.current = currentTime;
  };

  const handleDoubleTap = async record => {
    setSelectRow(record.index);
    const studyinstanceuid = await getStudyInstanceUid(record.register_key);
    setSelectPdfRowID(record.register_key);
    setModalities(record.modalities);
    setClinicalDiagnosis(record.clinical_diagnosis);
    setCheckLook(record.check_view2);
    setDiagnosticResults(record.diagnosis_result2);
    setPatient_history(record.patient_history);
    setCurrentState(record.state);

    if (!studyinstanceuid) {
      messageApi.error('获取 StudyInstanceUID 失败，请重试');
      return;
    }

    const currentSearchParams = new URLSearchParams();
    currentSearchParams.set('p_studyInstanceUid', studyinstanceuid);
    const queryString = currentSearchParams.toString();
    navigate(
      `/reportdetail${queryString ? `?${queryString}&from=mobilepage&flag=viewer` : 'from=mobilepage&flag=viewer'}`,
      {
        state: {
          rowData: record,
        },
      }
    );
  };

  return (
    <>
      {contextHolder}
      <ConfigProvider locale={zhCN}>
        <div className="mobile-main-page-wrap">
          <h3 className={!hideQuery ? 'header-query-title' : 'header-title'}>
            {hideQuery && (
              <div>
                <Button
                  type="primary"
                  htmlType="reset"
                  onClick={handleHidden}
                >
                  返回
                </Button>
              </div>
            )}
            <span>{!hideQuery ? '查询条件' : '工作列表'}</span>
            {hideQuery && (
              <div>
                <Button
                  type="primary"
                  onClick={() => handleViewer('image')}
                >
                  详情
                </Button>
                {/* {Number(currentState) >= 3 && (
                  <Button
                    type="primary"
                    onClick={() => handleViewer('pdf')}
                    style={{ marginLeft: '10px' }}
                  >
                    报告
                  </Button>
                )} */}
              </div>
            )}
          </h3>
          {!hideQuery && (
            <div className="mobile-left-wrap">
              <ul>
                <Form
                  ref={myform}
                  name="basic"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ maxWidth: 600 }}
                  autoComplete="off"
                  initialValues={newFilterValues}
                  form={form}
                  onFinish={onFinish}
                >
                  <Form.Item
                    label="开始时间"
                    name="register_time_begin"
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                      placeholder="开始时间"
                      inputReadOnly={true}
                      allowClear={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label="结束时间"
                    name="register_time_end"
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                      placeholder="结束时间"
                      inputReadOnly={true}
                      allowClear={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label="检查类型"
                    name="modality_code"
                  >
                    <Select
                      allowClear
                      style={{ width: '100%' }}
                      options={allModalities}
                      mode="multiple"
                      showSearch={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label="编号"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                    <div className="type_select">
                      <Form.Item
                        name="no_type"
                        style={{ display: 'inline-block', width: '33.3%' }}
                      >
                        <Select
                          style={{ width: '100%' }}
                          options={[
                            { label: 'ID号', value: 'patient_id' },
                            { label: '住院号', value: 'in_no' },
                            { label: '门诊号', value: 'out_no' },
                            { label: '检查号', value: 'study_id' },
                          ]}
                          placeholder="编号"
                          onChange={handleChangeType}
                        />
                      </Form.Item>
                      <Form.Item
                        name="no_value"
                        style={{ display: 'inline-block', width: '66.6%' }}
                      >
                        <Input
                          allowClear
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </div>
                  </Form.Item>

                  <Form.Item
                    label="病人姓名"
                    name="chinese_name"
                  >
                    <Input allowClear />
                  </Form.Item>

                  <Form.Item
                    label="检查所见"
                    name="check_view2"
                  >
                    <Input allowClear />
                  </Form.Item>

                  <Form.Item
                    label="检查结果"
                    name="diagnosis_result2"
                  >
                    <Input allowClear />
                  </Form.Item>

                  <Form.Item
                    label="送检科室"
                    name="register_dept"
                  >
                    <Select
                      allowClear
                      style={{ width: '100%' }}
                      options={dept}
                      onChange={handleChangeDept}
                    />
                  </Form.Item>

                  <Form.Item
                    label="送检人员"
                    name="register_man"
                  >
                    <Select
                      allowClear
                      style={{ width: '100%' }}
                      options={person}
                    />
                  </Form.Item>

                  <div className="btn-box-wrap">
                    <Form.Item
                      wrapperCol={{ span: 24 }}
                      style={{ margin: '0 auto', width: '100%' }}
                    >
                      <div className="btn-box-con">
                        <Button
                          type="primary"
                          htmlType="reset"
                          style={{ marginRight: '30px', fontSize: '18px' }}
                          onClick={handleReset}
                        >
                          重置
                        </Button>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ fontSize: '18px' }}
                        >
                          查询
                        </Button>
                      </div>
                    </Form.Item>
                  </div>
                </Form>
              </ul>
            </div>
          )}

          <div
            ref={eleRef}
            className="mobile-right-wrap"
            style={{ display: hideQuery ? 'block' : 'none' }}
          >
            <div className="right-top-wrap">
              <div
                className="table-wrap"
                ref={tableRef}
              >
                <Table
                  id="table1"
                  bordered
                  rowClassName={rowClassName}
                  rowKey={record => record.register_key}
                  columns={columns}
                  dataSource={newStudies}
                  showSorterTooltip={false}
                  loading={newTableLoading}
                  pagination={{
                    defaultCurrent: filterValues.currentPage,
                    current: filterValues.currentPage,
                    defaultPageSize: filterValues.pageSize,
                    total: newStudiesTotal,
                    showTotal: newStudiesTotal => `共 ${newStudiesTotal} 条`,
                    showSizeChanger: true,
                  }}
                  scroll={{ y: scrollY }}
                  onChange={handleChangeTable}
                  onRow={record => {
                    return {
                      onClick: event => {
                        setSelectRow(record.index);
                        setSelectPdfRowID(record.register_key);
                        setModalities(record.modalities);
                        setClinicalDiagnosis(record.clinical_diagnosis);
                        setCheckLook(record.check_view2);
                        setDiagnosticResults(record.diagnosis_result2);
                        setPatient_history(record.patient_history);
                        setCurrentState(record.state);
                        setRowData(record);
                      }, // 点击行
                      onTouchStart: handleTouchStart(record), // 手机端双击
                    };
                  }}
                />
              </div>
            </div>
            <div className="right-bottom-wrap">
              <Tabs
                type="card"
                tabPosition="bottom"
                defaultActiveKey="1"
                items={items}
              ></Tabs>
            </div>
          </div>
        </div>
      </ConfigProvider>
    </>
  );
};

MobilePage.propTypes = {
  studies: PropTypes.array.isRequired,
  studiesTotal: PropTypes.number.isRequired,
  tableLoading: PropTypes.bool.isRequired,
  onValuesChange: PropTypes.func.isRequired,
  getDay: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  normalizeDataIndex: PropTypes.func.isRequired,
  filtersMeta: PropTypes.arrayOf(
    PropTypes.shape({
      /** Identifier used to map a field to it's value in `filterValues` */
      name: PropTypes.string.isRequired,
      /** Friendly label for filter field */
      displayName: PropTypes.string.isRequired,
      /** One of the supported filter field input types */
      inputType: PropTypes.oneOf(['Text', 'MultiSelect', 'DateRange', 'None']).isRequired,
      isSortable: PropTypes.bool.isRequired,
      /** Size of filter field in a 12-grid system */
      gridCol: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).isRequired,
      /** Options for a "MultiSelect" inputType */
      option: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          label: PropTypes.string,
        })
      ),
    })
  ).isRequired,
};

export default MobilePage;
